import { z } from 'zod';

export type MessageFormatter = (msg: { id: string; defaultMessage: string }) => string;

const nameRequiredMsg = {
  id: 'common.required',
  defaultMessage: 'Requerido',
};
const contentRequiredMsg = {
  id: 'common.required',
  defaultMessage: 'Requerido',
};
const onlyOneDefaultMsg = {
  id: 'admin.fragments.twoDefaultsNotAllowed',
  defaultMessage: 'No puede haber dos footers establecidos como default',
};

/** Zod schema for a single description footer entry. */
export function getDescriptionFooterSchema(t: MessageFormatter) {
  return z.object({
    name: z.string().min(1, t(nameRequiredMsg)),
    content: z.string().min(1, t(contentRequiredMsg)),
    default: z.boolean(),
  });
}

/** Zod schema for the description footers form values. */
export function getSchema(t: MessageFormatter) {
  const footerSchema = getDescriptionFooterSchema(t);
  return z
    .object({
      descriptionFooters: z.array(footerSchema),
    })
    .refine((data) => data.descriptionFooters.filter((footer) => footer.default).length <= 1, {
      message: t(onlyOneDefaultMsg),
      path: ['descriptionFooters', 'root'],
    });
}

export type DescriptionFootersFormValues = z.infer<ReturnType<typeof getSchema>>;
